// src/components/dashboard/CompanyStats.tsx - LAYOUT HORIZONTAL FIXO
import React from "react";
import type { Stats } from "../../types/domain";

interface CompanyStatsProps {
  stats: Stats;
  loading: boolean;
}

export const CompanyStats: React.FC<CompanyStatsProps> = ({
  stats,
  loading,
}) => {
  if (loading) {
    return (
      <div className="flex flex-wrap gap-6 mb-8 justify-center">
        {[1, 2, 3].map((i) => (
          <div 
            key={i} 
            className="w-[200px] bg-card rounded-xl shadow-sm p-6 animate-pulse border border-border"
          >
            <div className="h-4 bg-muted rounded w-3/4 mb-3"></div>
            <div className="h-8 bg-muted rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  const statCards = [
    {
      title: "Total de Empresas",
      value: stats.total,
      color: "border-primary",
      textColor: "text-foreground",
      bgColor: "bg-card",
    },
    {
      title: "Empresas Ativas",
      value: stats.active,
      color: "border-chart-2",
      textColor: "text-chart-2",
      bgColor: "bg-card",
    },
    {
      title: "Empresas Inativas",
      value: stats.inactive,
      color: "border-destructive",
      textColor: "text-destructive",
      bgColor: "bg-card",
    },
  ];

  return (
    <div className="mb-8">
      {/* Cabeçalho da seção */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground mb-2">
          Visão Geral
        </h2>
        <p className="text-muted-foreground text-sm">
          Estatísticas gerais das empresas cadastradas
        </p>
      </div>

      {/* Container Flexbox para cards horizontais */}
      <div className="flex flex-wrap gap-6 justify-center">
        {statCards.map((card, index) => (
          <div
            key={index}
            className={`
              w-[200px]
              ${card.bgColor} 
              rounded-xl 
              shadow-sm 
              p-6 
              border-l-4 
              ${card.color}
              border 
              border-border
              transition-all 
              duration-200 
              hover:shadow-md 
              hover:translate-y-[-2px]
              flex-shrink-0
            `}
          >
            <h3 className="text-muted-foreground text-sm font-medium mb-2">
              {card.title}
            </h3>
            <p className={`text-3xl font-bold ${card.textColor}`}>
              {card.value}
            </p>
            
            {/* Indicador visual adicional */}
            <div className="mt-4 flex items-center">
              <div className={`w-3 h-3 rounded-full ${card.textColor.replace('text-', 'bg-')} mr-2`}></div>
              <span className="text-xs text-muted-foreground">
                {card.title.split(' ')[1].toLowerCase()}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Barra de progresso visual (opcional) */}
      {stats.total > 0 && (
        <div className="mt-6 bg-muted rounded-full h-2 overflow-hidden max-w-md mx-auto">
          <div 
            className="bg-chart-2 h-full transition-all duration-500"
            style={{ 
              width: `${(stats.active / stats.total) * 100}%` 
            }}
          ></div>
        </div>
      )}
    </div>
  );
};